module.exports = __webpack_public_path__ + "img/6.41fa06d7.png";